import React, { useContext, useEffect, useState, useRef } from 'react'
import { getSupplierDetailsData } from '_services/accountsServices/supplierServices';
import { CommonInput } from 'components';
import { UserContext } from 'context';
import { utils } from 'helper';
import { useParams } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import { constant } from 'constants/constant';
import { AttachedFileModal } from 'modals';
import ImagePreview from 'modals/LrDetailModal/ImagePreview';
import Loading from 'pages/Loading';

const SupplierDetailsTab = ({ supplierDataFunc, supplierDetails }) => {

    let { id } = useParams();
    const loadingBarRef = useRef(null);
    const { masterData } = useContext(UserContext)
    const [detailsData, setDetailsData] = useState({})
    const [loading, setLoading] = useState(false);
    const [showAttachedModal, setShowAttachedModal] = useState({
        open: false,
        data: [],
    });

    const [imagePreview, setImagePreview] = useState({})

    const getDataSupplierDetails = async (id_1) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                supplier_id: id_1,
            }
            const res = await getSupplierDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.supplier)
                supplierDataFunc(res?.data?.supplier)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        if (id || !supplierDetails?._id) {
            setLoading(true);
            getDataSupplierDetails(id);
        }
    }, [id])

    let attachedModal = {
        isOpen: showAttachedModal?.open,
        closeModal: (e) =>
            setShowAttachedModal((pre) => ({ ...pre, open: false, data: [] })),
        headerPart: false,
        footerPart: false,
        modalMainClass: "_dashCommon_Modal _AttachmentModal",
        modalTitle: "Attachment",
        submitTitle: "Add",
        cancelButtonTitle: "Cancel",
        showAttachedModal: showAttachedModal,
        // getMaterial: (e) => getMaterial()
        // getBanner: (e) => getBanner()
    };

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        modalZIndex: 999999,
        closeModal: (e) => setImagePreview(false),
    }

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            {
                loading ?
                    <div className='h-100 position-relative justify-content-center align-items-center d-flex'> <Loading /> </div>
                    : (
                        <div className='fl-height-auto' >
                            <div className='_ptyDetail_bx'>
                                <div className="inrPrt_bxs">
                                    <div className='_inrPrt_head'>Basic Details</div>
                                    <div className='_inrPrt_flx'>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                placeholder="Supplier Name"
                                                label="Supplier Name *"
                                                name='name'
                                                value={detailsData?.name}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Mobile Number"
                                                placeholder="Mobile Number"
                                                value={detailsData?.contact_no}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Alternate Mobile Number"
                                                placeholder="Alternate Mobile Number"
                                                value={detailsData?.alt_contact_no}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Email ID"
                                                placeholder="Email ID"
                                                value={detailsData?.email}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Opening Balance (₹)"
                                                placeholder="Opening Balance (₹)"
                                                value={detailsData?.opening_balance ? `₹ ${detailsData?.opening_balance}` : ""}
                                                disabled
                                            />
                                        </div>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="As of Date"
                                                placeholder="As of Date"
                                                value={utils.dd_mm_yy_formatDate(detailsData?.as_of_date)}
                                                disabled
                                            />
                                        </div>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Message Language"
                                                placeholder="Message Language"
                                                value={constant.languageArray?.find((el) => el?.iso_code === detailsData?.message_lang)?.label}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="inrPrt_bxs ">
                                    <div className='_inrPrt_head'> Address </div>
                                    <div className='_inrPrt_flx _min_h_auto'>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="Address Line 1"
                                                placeholder="Address Line 1"
                                                value={detailsData?.address_line1}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="State"
                                                placeholder="State"
                                                value={detailsData?.state?.label}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="City"
                                                placeholder="City"
                                                value={detailsData?.city?.label}
                                                disabled
                                            />
                                        </div>

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="PIN Code"
                                                placeholder="PIN Code"
                                                value={detailsData?.pincode}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="inrPrt_bxs">
                                    <div className='_inrPrt_head'>Tax Info</div>
                                    <div className='_inrPrt_flx _min_h_auto'>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="GST Type"
                                                placeholder="GST Type"
                                                value={masterData?.gst_type_list?.filter((el) => (el?.id == detailsData?.gst_type))[0]?.name}
                                                disabled
                                            />
                                        </div>

                                        {
                                            detailsData?.gst_no ? (
                                                <div className='_divForth'>
                                                    <CommonInput
                                                        type="text"
                                                        label="GST Number"
                                                        placeholder="GST Number"
                                                        value={detailsData?.gst_no}
                                                        disabled
                                                    />
                                                </div>
                                            ) : <></>
                                        }

                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="GST State"
                                                placeholder="GST State"
                                                value={detailsData?.gst_state?.label}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="inrPrt_bxs">
                                    <div className='_inrPrt_head'> Other Details </div>
                                    <div className='_inrPrt_flx'>
                                        <div className='_divForth'>
                                            <CommonInput
                                                type="text"
                                                label="TDS Applicable"
                                                placeholder="TDS Applicable"
                                                value={detailsData?.tds_deduction ? `${detailsData?.tds_deduction}%` : "0" + '%'}
                                                disabled
                                            />
                                        </div>

                                        {
                                            detailsData?.tds_declaration_form?.length > 0 && (
                                                <div className='singleDiv'>
                                                    <div className='attechFile_head mb-2'>  TDS Declaration Files : {detailsData?.tds_declaration_form?.length} </div>
                                                    {
                                                        detailsData?.tds_declaration_form?.map((el, ind) => {
                                                            return (
                                                                <div className='p-2' onClick={() => setImagePreview({ url: `${masterData?.s3_url}${el?.path}`, preview: true })}>
                                                                    <p className='__highLight_Heading'> {el?.filename ? el?.filename?.split('.')[0] : ''} </p>
                                                                    {/* <a href={`${masterData?.s3_url}${el?.path}`} key={ind}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setShowAttachedModal((pre) => ({
                                                                            ...pre,
                                                                            open: true,
                                                                            data: [{ path: `${el?.path}` }],
                                                                        }));
                                                                    }} > {el?.filename} </a> */}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        }

                                        <div className='_divForth'>

                                            <CommonInput
                                                type="text"
                                                label="PAN Number"
                                                placeholder="PAN Number"
                                                value={detailsData?.pan_no}
                                                disabled
                                            />
                                        </div>
                                        {detailsData?.pan_image && <div className='_divForth' style={{ flex: '0 0 100%' }}>
                                            <div className='p-2'
                                                onClick={() => setImagePreview({ url: `${masterData?.s3_url}${detailsData?.pan_image}`, preview: true })}
                                                style={{ cursor: "pointer" }}>
                                                <p className='__highLight_Heading'> {detailsData?.pan_image ? detailsData?.pan_image?.split('.')[0] : ''} </p>
                                                {/* <a
                                                href={`${masterData?.s3_url}${detailsData?.pan_image}`}
                                                key={detailsData?.pan_image} onClick={(e) => {
                                                    e.stopPropagation();
                                                    setShowAttachedModal((pre) => ({
                                                        ...pre,
                                                        open: true,
                                                        data: [{ path: `${detailsData?.pan_image}` }],
                                                    }));
                                                }}> {detailsData?.pan_image} </a> */}
                                            </div>
                                        </div>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    )
            }

            {showAttachedModal?.open && <AttachedFileModal {...attachedModal} />}

            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }
        </>
    )
}

export default SupplierDetailsTab